<template>
  <span class="performance-cell">
    <span class="performance-cell__value">{{ value }}</span>
    <span
      v-if="delta"
      class="performance-cell__delta"
      :class="`performance-cell__delta--${delta.direction}`"
    >
      {{ delta.direction === 'up' ? '▲' : '▼' }} {{ delta.label }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'BasePerformanceCell',
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    delta: {
      type: Object,
      required: false,
      default: null,
      validator: (value) => !value || ['up', 'down'].includes(value.direction)
    }
  }
}
</script>

<style lang="scss">
.performance-cell {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 12.5px;
  font-weight: 700;

  &__delta {
    font-size: 10.5px;
    font-weight: 600;

    &--up {
      color: var(--v-successDarken-base);
    }

    &--down {
      color: var(--v-errorDarken-base);
    }
  }
}
</style>
